import { Popover as PopoverPrimitive } from "@base-ui/react/popover";
import type React from "react";
import { Popover, PopoverPopup, PopoverTrigger } from "@/components/ui/popover";

/**
 * Infotip — popover that opens on hover and tap when the trigger exists only to show the popup.
 * Use `Tooltip` when the trigger is a control with its own job (focus/hover supplementary text).
 *
 * @see https://base-ui.com/react/components/tooltip#alternatives-to-tooltips
 */
export const Infotip: typeof PopoverPrimitive.Root = Popover;

export function InfotipTrigger(props: Omit<PopoverPrimitive.Trigger.Props, "openOnHover">): React.ReactElement {
    return <PopoverTrigger {...props} openOnHover />;
}

export function InfotipPopup(
    props: Omit<React.ComponentProps<typeof PopoverPopup>, "tooltipStyle">,
): React.ReactElement {
    return <PopoverPopup {...props} tooltipStyle />;
}
